import {Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {LczDataService, LczEvent, LczEventOptions} from "../lcz-data.service";
import {AngularFirestoreCollection} from "@angular/fire/firestore";
import * as _moment from 'moment';

interface LczEventForm {
  date: string;
  comment: string;
  off: LczEventOptions;
}

interface LczEventForms {
  [key: string]: LczEventForm
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  members = [
    {
      id: 'm_001',
      name: 'Albi',
      group: 'a'
    },
    // {
    //   id: 'm_002',
    //   name: 'Antje',
    //   group: 'a'
    // },
    {
      id: 'anan',
      name: 'Anan',
      group: 'a'
    },
    {
      id: 'm_2023_004',
      name: 'Christian',
      group: 'a'
    },
    {
      id: 'm_003',
      name: 'Cornelius',
      group: 'a'
    },
    {
      id: 'm_004',
      name: 'Dede',
      group: 'p'
    },
    {
      id: 'm_005',
      name: 'Edi',
      group: 'a'
    },
    {
      id: 'm_006',
      name: 'Ernst',
      group: 'a'
    },
    {
      id: 'm_007',
      name: 'Erol',
      group: 'p'
    },
    {
      id: 'm_017',
      name: 'Gerda',
      group: 'p'
    },
    {
      id: 'm_2023_005',
      name: 'Hendrik',
      group: 'a'
    },
    {
      id: 'm_009',
      name: 'Jörg',
      group: 'p'
    },
    {
      id: 'm_019',
      name: 'Jonas',
      group: 'a'
    },
    {
      id: 'm_010',
      name: 'Jules',
      group: 'a'
    },
    {
      id: 'm_011',
      name: 'Kurt',
      group: 'p'
    },

    {
      id: 'm_2023_002',
      name: 'Max',
      group: 'a'
    },
    {
      id: 'm_2023_001',
      name: 'Maximilian',
      group: 'a'
    },
    {
      id: 'm_2023_003',
      name: 'Nicky',
      group: 'a'
    },

    // {
    //   id: 'm_012',
    //   name: 'Paul',
    //   group: 'a'
    // },
    {
      id: 'm_013',
      name: 'Peter',
      group: 'a'
    },
    {
      id: 'm_014',
      name: 'Petra',
      group: 'p'
    },
    {
      id: 'm_015',
      name: 'Ruth',
      group: 'p'
    },
    // {
    //   id: 'm_018',
    //   name: 'Stefan',
    //   group: 'a'
    // },
    {
      id: 'm_016',
      name: 'Walter',
      group: 'p'
    }
  ];

  eventData = {};

  latestEvent:string = '';
  activeEventForm:string = '';
  eventForm: LczEventForm;

  constructor(
    private lczData: LczDataService
  ) {
  }

  private eventCollection: AngularFirestoreCollection<LczEvent>;
  eventArray: Observable<string[]>;

  toggleEventForm(eventId){
    if(this.activeEventForm !== eventId) {
      let form = this.defaultEventForm();
      const data = this.eventData[eventId];
      if (data) {
        if (data.date && data.date.string) {
          form.date = data.date.string;
        }
        if (data.comment) {
          form.comment = data.comment;
        }
        if (data.off) {
          form.off = data.off;
        }
      }
      this.eventForm = form;
      this.activeEventForm = eventId;
    } else {
      this.activeEventForm = '';
      this.eventForm = this.defaultEventForm();
    }
    // const now = _moment(value) ;

  }
  saveEventForm(eid){

    const data = this.eventForm;
    const _this = this;
    let payload = {};
    let optionCount = 0;
    let offCount = 0;

    if(data) {

      payload = {
        date: this.lczData.makeDate(data.date),
        off: data.off,
        comment: data.comment
      };

      Object.keys(data.off).forEach(key => {
        if(key !== '_all') {
          optionCount += 1;
          if (data.off[key]) {
            offCount += 1;
          }
        }
      });

      payload['off']['_all'] = (optionCount == offCount);

    }

    function onSuccess(response) {
      _this.toggleEventForm(eid);
    }
    function onError(response) {
      _this.toggleEventForm(eid);
    }

    return this.lczData.updateEvent(eid,payload).then(onSuccess,onError).catch(onError);
  }

  calculateStats(attendees){

    const activities = (
      attendees
    ) ? Object.keys(attendees) : [];
    let stats = {}

    activities.forEach(activity => {
      let count = {
        y: 0,
        n: 0
      };
      const items = Object.keys(attendees[activity]);
      items.forEach(item => {
        count[attendees[activity][item]] += 1;
      });
      stats[activity] = count;
    })

    return stats;

  }


  private defaultEventForm():LczEventForm {
    return {
      date: '',
      comment: '',
      off: {
        basketball: false,
        turnen: false
      }
    };
  }



  ngOnInit() {

    const now = this.lczData.makeDate();

    this.eventForm = this.defaultEventForm();

    this.eventCollection = this.lczData.queryEvents({
      limit: 48,
      where: [
        {property: 'date.stamp', operator: '>=', value: now.stamp}
      ],
      orderBy: {property: 'date.stamp', operator: 'asc'}
    });
    this.eventArray = this.eventCollection.snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as LczEvent;
        const stats = <LczEventOptions>this.calculateStats(data.attendees);
        const id = a.payload.doc.id;
        this.eventData[id] = Object.assign({}, data, {stats:stats});
        this.latestEvent = id;
        return id;
      }))
    );

  }

  // onChangeDate(eventId) {
  //   this.lczData.updateEvent(eventId,{
  //       date: this.eventData[eventId].date
  //   });
  // }

  createEvent() {
    const nextMonday = this.getNextMonday();
    const payload = {
      date: this.lczData.makeDate(nextMonday)
    };
    this.lczData.createEvent(payload);
  }

  onAttendOption(value, context) {

    if(!this.eventData[context.event].attendees[context.option]){
      this.eventData[context.event].attendees[context.option] = {};
    }

    this.eventData[context.event].attendees[context.option][context.member] = value;
    const attendees = this.eventData[context.event].attendees[context.option];

    // let count = 0;
    // Object.keys(attendees).forEach(value => {
    //   if (attendees[value] === 'y') {
    //     count += 1;
    //   }
    // });

    // const pathCount = ['count', context.option].join('.');
    const pathAttend = ['attendees', context.option, context.member].join('.');

    let payload = {};
    payload[pathAttend] = value;
    // payload[pathCount] = count;

    this.lczData.updateEvent(context.event,payload);

  }

  private getNextMonday(){

    let nextWeek =  false;
    let date;

    if (
      this.latestEvent &&
      this.eventData &&
      this.eventData[this.latestEvent] &&
      this.eventData[this.latestEvent].date &&
      this.eventData[this.latestEvent].date.string
    ) {
      nextWeek = true;
      date = _moment(this.eventData[this.latestEvent].date.string);
    } else {
      date = _moment();
    }

    const dayINeed = 1; // for Monday
    const day = date.isoWeekday();
    let next;

// if we haven't yet passed the day of the week that I need:
    if (!nextWeek && day <= dayINeed) {
      // then just give me this week's instance of that day
      next =  date.isoWeekday(dayINeed);
    } else {
      // otherwise, give me *next week's* instance of that same day
      next =  date.add(1, 'weeks').isoWeekday(dayINeed);
    }
    return next;
  }

}
